import * as paiementSouscriptionFormNames from "./paiementSouscriptionFormNames";

export const paiementSouscriptionInitialValues = {
  [paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_PLATEFORME_PAIEMENT_FORM_NAME]:
    "",
  [paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_MODE_PAIEMENT_FORM_NAME]:
    "",
};
